function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from "react";
import styled from "styled-components";
import { Flex, Box, Text } from "sprout-ui-primitives";
import { media } from "sprout-ui-theme";
import { Menu, MenuItem, useMenuState, MenuTrigger } from "@sprout/list-navigation/dist/Menu";
import { Button as BaseButton } from "sprout-ui-dom/dist/Button";
import { NavLink } from "react-router-dom";
import { getItemUrl } from "sprout-lib";
import { MoreHoriz } from "sprout-ui-icons";
const Ol = styled(Flex)`
  list-style: none;

  li {
    display: inline-flex;
    min-width: 0;
  }

  ${media.target("pointer")} {
    a:hover {
      text-decoration: underline;
    }
  }
`;
const Button = styled(BaseButton)`
  width: 30px;
  height: 30px;
`;
const NavigationBreadcrumbs = (props)=>{
    const { owner , breadcrumbsList , className  } = props;
    const { username  } = owner;
    const total = breadcrumbsList.length;
    const noBetween = total <= 3;
    const [before, between, after] = useMemo(()=>{
        const itemsBeforeCollapse = 1;
        const itemsAfterCollapse = 1;
        if (noBetween) return [
            breadcrumbsList,
            [],
            []
        ];
        return [
            breadcrumbsList.slice(0, itemsBeforeCollapse),
            breadcrumbsList.slice(1, total - itemsAfterCollapse),
            breadcrumbsList.slice(total - itemsAfterCollapse, total), 
        ];
    }, [
        total,
        noBetween,
        breadcrumbsList
    ]);
    const menuState = useMenuState();
    if (breadcrumbsList.length === 0) return null;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Menu, _objectSpread({}, menuState, {
                placement: "bottom",
                children: between.map((topic)=>{
                    return /*#__PURE__*/ _jsx(MenuItem, {
                        to: getItemUrl(topic, owner),
                        label: topic.title || "No title"
                    }, topic.nodeId);
                })
            })),
            /*#__PURE__*/ _jsx(Box, {
                as: "nav",
                "aria-label": "Breadcrumb",
                minWidth: "0",
                px: 2,
                className: className,
                children: /*#__PURE__*/ _jsxs(Ol, {
                    as: "ol",
                    color: "blue.500",
                    alignItems: "center",
                    minHeight: "32px",
                    children: [
                        before.map((topic, index)=>{
                            const lastItem = before.length === index + 1;
                            const isProfileTopic = topic.special === "PROFILE";
                            const label = isProfileTopic ? username : topic.title || "No title";
                            const to = isProfileTopic ? `/${username}` : getItemUrl(topic, owner);
                            return /*#__PURE__*/ _jsxs("li", {
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        truncate: true,
                                        as: NavLink,
                                        exact: true,
                                        to: to,
                                        children: label
                                    }),
                                    !lastItem && noBetween && /*#__PURE__*/ _jsx(Box, {
                                        as: "span",
                                        px: "12px",
                                        children: "/"
                                    })
                                ]
                            }, topic.nodeId);
                        }),
                        between.length !== 0 && /*#__PURE__*/ _jsxs(Flex, {
                            as: "li",
                            alignItems: "center",
                            flex: "none",
                            children: [
                                /*#__PURE__*/ _jsx(Box, {
                                    as: "span",
                                    pl: "12px",
                                    pr: "4px",
                                    children: "/"
                                }),
                                /*#__PURE__*/ _jsx(MenuTrigger, _objectSpread({}, menuState, {
                                    children: /*#__PURE__*/ _jsx(Button, {
                                        variant: "circle",
                                        children: /*#__PURE__*/ _jsx(MoreHoriz, {})
                                    })
                                })),
                                /*#__PURE__*/ _jsx(Box, {
                                    as: "span",
                                    pl: "4px",
                                    pr: "12px",
                                    children: "/"
                                })
                            ]
                        }),
                        after.map((topic)=>{
                            const topicTitle = topic.title || "No title";
                            return /*#__PURE__*/ _jsx("li", {
                                children: /*#__PURE__*/ _jsx(Text, {
                                    truncate: true,
                                    as: NavLink,
                                    exact: true,
                                    to: getItemUrl(topic, owner),
                                    children: topicTitle
                                })
                            }, topic.nodeId);
                        })
                    ]
                })
            })
        ]
    });
};
export default NavigationBreadcrumbs;
